/**
 * @enum {String}
 */
export const ACTIVITY_TYPES = {
  ISSUE_RAISED: "Issue Raised",
  ALLOTTED_TO_GROUND_STAFF: "Allotted to Ground Staff",
  ISSUE_RESOLVED: "Issue Resolved",
  COMMENT: "Comment",
  RECEIVED_BY_DEPARTMENT: "Received by Department",
  IN_PROGRESS: "In Progress"
};
